import { IScheduleTaskAttributeResourceCalculationKey } from '../../interfaces/ischedule-task-attribute-resource-calculation-key';
import { ResourceCalculation } from '../resource-calculation';
import { ScheduleTaskAttribute } from '../schedule-task-attribute';

export class ScheduleTaskAttributeResourceCalculationKeyBase {
  ScheduleTaskAttributeResourceCalculationKeyId: number;
  ScheduleTaskAttributeId: number;
  ResourceCalculationId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ResourceCalculation?: ResourceCalculation;
  ScheduleTaskAttribute?: ScheduleTaskAttribute;

  constructor(item?: IScheduleTaskAttributeResourceCalculationKey) {
    if (item) {

      this.ScheduleTaskAttributeResourceCalculationKeyId = item.ScheduleTaskAttributeResourceCalculationKeyId;
      this.ScheduleTaskAttributeId = item.ScheduleTaskAttributeId;
      this.ResourceCalculationId = item.ResourceCalculationId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ResourceCalculation = new ResourceCalculation(item.ResourceCalculation);
      this.ScheduleTaskAttribute = new ScheduleTaskAttribute(item.ScheduleTaskAttribute);
    }
  }
}